import { Component, useEffect, useState } from "react";
import Cookies from "js-cookie"

function Header(props) {
  const [userUid, setUserUid] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const uid = Cookies.get("uid");
    setUserUid(uid);
    
    if (uid) {
      fetchUserInfo(uid);
    }
  }, []);

  const fetchUserInfo = async (uid) => {
    setLoading(true);
    try {
      const userResponse = await fetch(`https://api1.ororigin.xyz/api/user/${uid}`);
      const userData = await userResponse.json();
      
      if (userData.success) {
        setUserInfo(userData.user);
        setAvatarUrl(`https://api1.ororigin.xyz/api/user/avatar/${uid}`);
      }
    } catch (error) {
      console.error("获取用户信息失败:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    Cookies.remove("uid");
    setUserUid(null);
    setUserInfo(null);
    setAvatarUrl(null);
    window.location.href = "/#index";
  };

  return (
    <div
      className={props.shouldHeadStyle2Active ? "header active" : "header"}
      style={{ top: props.isLoading ? "-200px" : 0 }}
    >
      <a className="header-logo" href="#index">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          className="header-logo-icon"
        >
          <defs>
            <style>
              {`
            .st0, .st1, .st2, .st3 {
              stroke:#ffefd5;
              stroke-miterlimit: 10;
            }
            .st0, .st3 {
              fill: none;
            }
            .st1 {
              fill: #000;
            }
            .st2{
              fill:#ffefd5;
            }
            .st3 {
              stroke-linecap: round;
            }
          `}
            </style>
          </defs>

          <path className="st1" d="M-11.25-44.03" />
          <g>
            <path className="st0" d="M13.96,1.26" />
            <polyline
              className="st0"
              points="7.85 13.9 13.42 11.82 13.42 5.49 8.06 7.46"
            />
            <polyline className="st0" points="2.77 7.76 2.77 5.64 7.9 7.5" />
            <line className="st0" x1="2.77" y1="8.59" x2="2.77" y2="7.51" />
            <line className="st0" x1="2.77" y1="10.06" x2="2.77" y2="8.59" />
            <polyline
              className="st0"
              points="8.21 13.9 2.77 11.75 2.77 10.06"
            />
            <line className="st3" x1="8.12" y1="7.51" x2="8.12" y2="13.8" />
            <line className="st3" x1="8.04" y1="2.71" x2="13.42" y2="4.83" />
            <line className="st3" x1="7.94" y1="2.68" x2="2.76" y2="4.97" />
            <polygon
              className="st2"
              points="8.54 13.46 13.3 11.56 13.24 5.56 8.44 7.44 8.54 13.46"
            />
            <polygon
              className="st2"
              points="4.33 10.49 6.36 11.31 6.39 8.58 4.3 7.79 4.33 10.49"
            />
          </g>
        </svg>
        <p className="header-logo-name">天地源</p>
      </a>
      
      <div className="header-navigation-container">
        <nav className="header-navigation">
          <a
            className="header-nav-items 1"
            href="/#index"
            style={{ color: props.nowPage === 1 ? "#ffd769" : "white" }}
          >
            首页
          </a>
          <a
            className="header-nav-items 2"
            href="/#gallery"
            style={{ color: props.nowPage === 2 ? "#ffd769" : "white" }}
          >
            画廊
          </a>
          <a
            className="header-nav-items 3"
            href="/#members"
            style={{ color: props.nowPage === 3 ? "#ffd769" : "white" }}
          >
            成员
          </a>
        </nav>
        <div
          className="header-nav-line"
          style={{
            marginLeft:
              props.nowPage === 1
                ? "1.15rem"
                : props.nowPage === 2
                  ? "5.65rem"
                  : "10.1rem",
          }}
        ></div>
      </div>
      
      <div className="header-cplink-container">
        <a className="header-cplink" href="/control-panel">控制面板</a>
      </div>

      <div className="header-user-container">
        {loading ? (
          <div className="user-loading">
            <div className="loading-spinner"></div>
          </div>
        ) : userUid && userInfo ? (
          <div className="user-info">
            <div className="user-avatar-container">
              <img 
                src={avatarUrl} 
                alt={userInfo.username || "用户"}
                className="user-avatar"
                onError={(e) => {
                  e.target.src = `https://api1.ororigin.xyz/api/user/avatar/default`;
                }}
              />
            </div>
            <div className="user-details">
              <span className="user-name">{userInfo.username || userInfo.name || "用户"}</span>
              <button className="logout-btn" onClick={handleLogout}>退出</button>
            </div>
          </div>
        ) : (
          <a className="login-btn" href="/auth">
            <i className="fas fa-user"></i>
            <span>
              登录</span>
          </a>
        )}
      </div>
    </div>
  );
}

export default Header;